import { AppUtil } from 'kuaidong-lib'
import { GlobalConfig, IGlobalConfigHomework, IFirstCategory, IDrillSimple, MenuRole } from 'kuaidong-model'

export class AGlobalConfig {
  public static async homework(): Promise<IGlobalConfigHomework> {
    return AppUtil.httpGET('/global/config/homework')
  }

  public static async allDrills(): Promise<{ [index: string]: IDrillSimple }> {
    return (await AppUtil.httpGET('/global/config/all_drill')).drills_info
  }

  /**
   * @deprecated
   * 获取全局配置，已废弃，请使用对应的具体配置
   */
  public static async getGlobalConfig(): Promise<GlobalConfig> {
    return AppUtil.httpGET('/global/config')
  }

  public static async getDrillCategory(): Promise<IFirstCategory[]> {
    return AppUtil.httpGET('/global/config/drill_category')
  }

  public static async buildShortUrl(url: string): Promise<string> {
    const result: any = await AppUtil.httpGET('/async/system/short_url', { url })
    return result.short_url
  }

  public static async menuRoles(): Promise<MenuRole> {
    return await AppUtil.httpGET('/global/config/menu_role?refresh=1')
  }
}
